export default "__VITE_ASSET__CUxqzA9Y__"